document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-fill-mix-shake]');

  sections.forEach((section) => {
    const stepsEl = section.querySelector('.fill-mix-shake__steps');
    const steps = [...section.querySelectorAll('.fill-mix-shake__step')];
    const images = [...section.querySelectorAll('.fill-mix-shake__image')];

    if (steps.length === 0) return;

    const interval = Number(section.dataset.interval) || 2000;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let activeIndex = 0;
    let timerId = null;

    const setActiveStep = (index) => {
      activeIndex = index;

      steps.forEach((step, stepIndex) => {
        const isActive = stepIndex === index;
        step.classList.toggle('fill-mix-shake__step--active', isActive);
        step.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (images.length > 1) {
        images.forEach((image, imageIndex) => {
          const isActive = imageIndex === index;
          image.classList.toggle('fill-mix-shake__image--active', isActive);

          const video = image.querySelector('video');
          if (!video) return;
          if (isActive) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }
    };

    const stopTimer = () => {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    };

    const advance = () => {
      const nextIndex = (activeIndex + 1) % steps.length;
      setActiveStep(nextIndex);
    };

    const startTimer = () => {
      if (steps.length < 2 || prefersReducedMotion) return;
      stopTimer();
      timerId = window.setInterval(advance, interval);
    };

    stepsEl?.addEventListener('click', (event) => {
      const step = event.target.closest('.fill-mix-shake__step');
      if (!step) return;
      setActiveStep(steps.indexOf(step));
      startTimer();
    });

    startTimer();
  });
});
